import styled from '@emotion/styled'

export const RadioButtonStyles = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  font-size: 0.875rem;
  margin-left: 1rem;
  font-weight: 700;
  color: rgba(var(--theme-text-dark-medium));
  cursor: pointer;

  .radio-button__input {
    position: absolute;
    height: 0;
    width: 0;
    opacity: 0;
  }

  .radio-button__input + span {
    position: relative;
    align-self: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.375rem 0.875rem 0.375rem 0.375rem;
    flex: 1 0 1.25rem;
    width: 1.25rem;
    max-width: 1.25rem;
    height: 1.25rem;
    max-height: 1.25rem;
    background: transparent;
    border: 1.5px solid rgba(0, 0, 0, 0.44);
    border-radius: 50%;
    cursor: pointer;
    transition: var(--theme-transition);
  }

  &:hover > span,
  .radio-button__input:focus + span {
    border-color: rgba(var(--theme-primary));
  }

  .radio-button__input:not(:checked):focus,
  .radio-button__input:focus + span {
    outline: none;
    box-shadow:
      0 0 0 1px rgba(var(--theme-snow)),
      0 0 0 3px rgba(var(--theme-primary), 0.2);
  }

  .radio-button__input:checked + span {
    border-color: rgba(var(--theme-primary));
    background: rgba(var(--theme-snow));
  }

  .radio-button__input + span:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 0;
    height: 0;
    background: rgba(var(--theme-primary));
    border-radius: 50%;
    transition: var(--theme-transition);
  }

  .radio-button__input:checked + span:before {
    width: 0.75rem;
    height: 0.75rem;
  }
`
export const Divider = styled.div`
  margin: 0.2rem;
  background-color: rgba(var(--theme-surface-lightgray));
  border-style: none;
  height: 1px;
  width: 90%;
  display: flex;
  align-self: center;

  &:last-child {
    display: none;
  }
`
